import {AfterViewChecked, Component, Input, OnInit} from '@angular/core';
import {TradeskillsService} from './tradeskills.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';

declare const refreshWowheadLinks: any;

@Component({
  selector: 'app-tradeskills',
  templateUrl: './tradeskills.component.html',
  styleUrls: ['./tradeskills.component.css']
})
export class TradeskillsComponent implements AfterViewChecked, OnInit {
  private static CHARACTER = 'character';
  private static CHARACTERS = 'characters';
  private static ERROR = 'error';
  private static GUILD = 'guild';
  private static GUILDS = 'guilds';
  private static ID = 'id';
  private static MESSAGE = 'message';
  private static NAME = 'name';
  private static RECIPES = 'recipes';
  private static RECIPE = 'recipe';
  private static SERVER = 'server';
  private static SERVERS = 'servers';
  private static SPELL_ID = 'spellId';
  private static TRADESKILL = 'tradeskill';
  private static TRADESKILLS = 'tradeskills';

  tradeskills = [];
  filteredTradeskills = [];
  @Input() uploadData: string;
  @Input() serverFilter = '';
  @Input() guildFilter = '';
  @Input() characterFilter = '';
  @Input() tradeskillFilter = '';
  @Input() recipeFilter = '';
  message = null;
  error = false;
  updateLinksRequired = true;
  uploadVisible = false;
  helpVisible = false;
  orderColumn = 'recipe';
  orderDirection = 1;
  MAX_TABLE_ENTRIES = 500;
  distinctServers = 0;
  distinctGuilds = 0;
  distinctCharacters = 0;
  distinctTradeskills = 0;
  distinctRecipies = 0;
  version: string;
  helpTooptip: string = 'Open the help window';
  downloadAddonTooptip: string = 'Download the addon from  CurseForge';
  uploadTooptip: string = 'Upload the tradeskills from the addon';
  exportCsvTooptip: string = 'Export all entries to a CSV file';
  saveFilterTooptip: string = 'Save the current filter as default filter';
  contactMeTooptip: string = 'Contact me on Discord';

  constructor(private route: ActivatedRoute, private router: Router, private tradeskillsService: TradeskillsService, private cookieService: CookieService) {
  }

  ngOnInit(): void {
    this.version = this.route.snapshot.queryParamMap.get('version');
    if (this.version === undefined || this.version === null) {
      this.router.navigate(['menu']);
    } else {
      this.loadTradeskills();
    }
    this.setDefaultFilters();
  }

  public loadTradeskills(): void {
    this.tradeskillsService.query(this.version).subscribe(result => {
      const recipes = [];
      this.tradeskills = [];
      result[TradeskillsComponent.TRADESKILLS].forEach(tradeskill => {
        tradeskill[TradeskillsComponent.RECIPES].forEach(recipe => {
          recipes[recipe[TradeskillsComponent.ID]] = {
            "tradeskill": tradeskill[TradeskillsComponent.NAME],
            "recipe": recipe[TradeskillsComponent.NAME],
            "spellId": recipe[TradeskillsComponent.SPELL_ID]
          };
        });
      });
      result[TradeskillsComponent.SERVERS].forEach(server => {
        server[TradeskillsComponent.GUILDS].forEach(guild => {
          guild[TradeskillsComponent.CHARACTERS].forEach(character => {
            character[TradeskillsComponent.RECIPES].forEach(recipeId => {
              this.tradeskills.push({
                "server": server[TradeskillsComponent.NAME],
                "guild": guild[TradeskillsComponent.NAME],
                "character": character[TradeskillsComponent.NAME],
                "tradeskill": recipes[recipeId][TradeskillsComponent.TRADESKILL],
                "recipe": recipes[recipeId][TradeskillsComponent.RECIPE],
                "spellId": recipes[recipeId][TradeskillsComponent.SPELL_ID]
              });
            });
          })
        });
      });
      this.filter();
    });
  }

  public ngAfterViewChecked(): void {
    if (this.updateLinksRequired) {
      refreshWowheadLinks();
      this.updateLinksRequired = false;
    }
  }

  public upload(): void {
    this.tradeskillsService.upload({uploadData: this.uploadData}).subscribe(uploadResponse => this.uploadCallback(uploadResponse));
  }

  private uploadCallback(uploadResponse: {}): void {
    this.error = uploadResponse[TradeskillsComponent.ERROR];
    this.message = uploadResponse[TradeskillsComponent.MESSAGE];
    this.loadTradeskills();
    if(!this.error) {
      this.uploadData = '';
    }
  }

  public setUploadData(event): void {
    this.uploadData = event.target.value;
  }

  public downloadAddon(): void {
    window.open('https://www.curseforge.com/wow/addons/tradeskillexporter/files', '_blank');
  }

  public contactMe(): void {
    window.open('https://discord.gg/XXMd9AUdVU', '_blank');
  }

  public openUpload(): void {
    this.uploadVisible = true;
  }

  public closeUpload(): void {
    this.uploadVisible = false;
    this.uploadData = '';
    this.message = null;
  }

  public openHelp(): void {
    this.helpVisible = true;
  }

  public closeHelp(): void {
    this.helpVisible = false;
  }

  public exportCsv(): void {
    this.tradeskillsService.exportCsv(this.version);
  }


  public orderBy(column: string): void {
    if (column === this.orderColumn) {
      this.orderDirection = -this.orderDirection;
    } else {
      this.orderColumn = column;
      this.orderDirection = 1;
    }
    this.filter();
  }

  public filter(): void {
    const uniqueServers = new Set();
    const uniqueGuilds = new Set();
    const uniqueCharacters = new Set();
    const uniqueTradeskills = new Set();
    const uniqueRecipies = new Set();
    this.tradeskills.sort((ts1, ts2) => this.orderDirection * (ts1[this.orderColumn] > ts2[this.orderColumn] ? 1 : -1));
    const filteredTradeskills = [];
    if (this.tradeskills !== undefined && this.tradeskills !== null) {
      for (const tradeskill of this.tradeskills) {
        if (this.serverFilter.length === 0
          || tradeskill[TradeskillsComponent.SERVER].toLowerCase().indexOf(this.serverFilter.toLowerCase()) !== -1) {
          if (this.guildFilter.length === 0
            || tradeskill[TradeskillsComponent.GUILD].toLowerCase().indexOf(this.guildFilter.toLowerCase()) !== -1) {
            if (this.characterFilter.length === 0
              || tradeskill[TradeskillsComponent.CHARACTER].toLowerCase().indexOf(this.characterFilter.toLowerCase()) !== -1) {
              if (this.tradeskillFilter.length === 0
                || tradeskill[TradeskillsComponent.TRADESKILL].toLowerCase().indexOf(this.tradeskillFilter.toLowerCase()) !== -1) {
                let match = true;
                for (const word of this.recipeFilter.split(' ')) {
                  if (tradeskill[TradeskillsComponent.RECIPE].toLowerCase().indexOf(word.toLowerCase()) === -1) {
                    match = false;
                    break;
                  }
                }
                if (match) {
                  if (filteredTradeskills.length < this.MAX_TABLE_ENTRIES) {
                    filteredTradeskills.push(tradeskill);
                  }
                  uniqueServers.add(tradeskill[TradeskillsComponent.SERVER]);
                  uniqueGuilds.add(tradeskill[TradeskillsComponent.GUILD]);
                  uniqueCharacters.add(tradeskill[TradeskillsComponent.CHARACTER]);
                  uniqueTradeskills.add(tradeskill[TradeskillsComponent.TRADESKILL]);
                  uniqueRecipies.add(tradeskill[TradeskillsComponent.RECIPE]);
                }
              }
            }
          }
        }
      }
    }
    this.distinctServers = uniqueServers.size;
    this.distinctGuilds = uniqueGuilds.size;
    this.distinctCharacters = uniqueCharacters.size;
    this.distinctTradeskills = uniqueTradeskills.size;
    this.distinctRecipies = uniqueRecipies.size;
    this.filteredTradeskills = filteredTradeskills;
    this.updateLinksRequired = true;
  }

  public saveFilter() {
    this.cookieService.set('filter_' + this.version + '_server', this.serverFilter, {expires: 1000000});
    this.cookieService.set('filter_' + this.version + '_guild', this.guildFilter, {expires: 1000000});
    this.cookieService.set('filter_' + this.version + '_character', this.characterFilter, {expires: 1000000});
    this.cookieService.set('filter_' + this.version + '_tradeskill', this.tradeskillFilter, {expires: 1000000});
    this.cookieService.set('filter_' + this.version + '_recipe', this.recipeFilter, {expires: 1000000});
  }

  private setDefaultFilters() {
    this.serverFilter = this.setFilter('server');
    this.guildFilter = this.setFilter('guild');
    this.characterFilter = this.setFilter('character');
    this.tradeskillFilter = this.setFilter('tradeskill');
    this.recipeFilter = this.setFilter('recipe');
  }

  private setFilter(filter: string) {
    const filterValue = this.cookieService.get('filter_' + this.version + '_' + filter);
    if(filterValue !== undefined && filterValue !== null && filterValue !== '') {
      return filterValue;
    }
    return '';
  }
}
